import { z } from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

import { ModelFilterSchema } from '../model-filter-schema.ts'
import { DollarsSchema, NonEmptyStringSchema } from './property.models.ts'
import { InvoiceIdSchema, InvoiceLineItemIdSchema } from './unique-id.models.ts'

export const InvoiceLineItemDomainSelectModelSchema = z.object({
  invoiceLineItemId: InvoiceLineItemIdSchema,
  invoiceId: InvoiceIdSchema,
  amount: DollarsSchema(),
  description: NonEmptyStringSchema(),
})

export type InvoiceLineItemDomainSelectModel = ZodInfer<
  typeof InvoiceLineItemDomainSelectModelSchema
>

export const InvoiceLineItemDomainInsertModelSchema =
  InvoiceLineItemDomainSelectModelSchema.partial({
    invoiceLineItemId: true,
  })

export type InvoiceLineItemDomainInsertModel = ZodInfer<
  typeof InvoiceLineItemDomainInsertModelSchema
>

export const InvoiceLineItemDomainUpdateModelSchema =
  InvoiceLineItemDomainSelectModelSchema.pick({
    amount: true,
    description: true,
  }).partial()

export type InvoiceLineItemDomainUpdateModel = ZodInfer<
  typeof InvoiceLineItemDomainUpdateModelSchema
>

export const InvoiceLineItemDomainSelectModelFiltersSchema = z
  .object({
    invoiceLineItemId: ModelFilterSchema(InvoiceLineItemIdSchema),
    invoiceId: ModelFilterSchema(InvoiceIdSchema),
  })
  .partial()

export type InvoiceLineItemDomainSelectModelFilters = ZodInfer<
  typeof InvoiceLineItemDomainSelectModelFiltersSchema
>
